/* eslint-disable react/prop-types */
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'
import clsx from 'clsx'
import _ from 'lodash'
import moment from 'moment'

import { makeStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import AddIcon from '@material-ui/icons/AddOutlined'
import ScheduleIcon from '@material-ui/icons/ScheduleOutlined'
import DescriptionIcon from '@material-ui/icons/DescriptionOutlined'
import PinIcon from '@material-ui/icons/RoomOutlined'
import HomeIcon from '@material-ui/icons/HomeOutlined'

import { LOGOUT } from '../../actions'
import InnerDrawer from './InnerDrawer.component'

const routesMocks = [{
  title: 'Inicio',
  route: '/dashboard',
  icon: <HomeIcon />,
}, {
  title: 'Iniciar un formulario',
  route: '/dashboard/forms/new',
  icon: <AddIcon />,
}, {
  title: 'Formularios finalizados',
  route: '/dashboard/forms/finalized',
  icon: <DescriptionIcon />,
}, {
  title: 'Formularios pendientes',
  route: '/dashboard/forms/pending',
  icon: <ScheduleIcon />,
}, {
  title: 'Mi Cartera',
  route: '/dashboard/points',
  icon: <PinIcon />,
}]

const useStyle = ({
  openDrawer,
  drawerWidth,
  linksOpen,
  metricsOpen,
}) => makeStyles(theme => ({
  drawer: {
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: !openDrawer
        ? (theme.spacing(7) + 1)
        : drawerWidth,
    },
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    [theme.breakpoints.down('xs')]: {
      width: linksOpen || metricsOpen
        ? drawerWidth
        : theme.spacing(7) + 1,
    },
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: !openDrawer
        ? (theme.spacing(7) + 1)
        : drawerWidth,
    },
  },
}))

export const DrawerComponent = props => {
  const {
    showLinksAndMetrics,
    showMyAdvance,
    openDrawer,
    handleDrawer,
    drawerWidth,
    profile,
    showLinks,
    logout,
  } = props
  const [mobileOpen, setMobileOpen] = React.useState(false)
  const [linksOpen, handleLinks] = React.useState(false)
  const [metricsOpen, handleMetrics] = React.useState(false)
  const [metricNumberSelected, handleMetricNumberSelected] = React.useState(null)

  const classes = useStyle({
    openDrawer,
    drawerWidth,
    linksOpen,
    metricsOpen,
  })()

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen)

  return (
    <div>
      <nav className={classes.drawer} aria-label='drawer-custom'>
        <Drawer
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: openDrawer,
            [classes.drawerClose]: !openDrawer,
          })}
          variant='permanent'
          anchor='left'
          open={mobileOpen}
          onClose={handleDrawerToggle}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: openDrawer,
              [classes.drawerClose]: !openDrawer,
            }),
          }}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <InnerDrawer
            logout={logout}
            showLinks={showLinks}
            openDrawer={openDrawer}
            linksOpen={linksOpen}
            routes={routesMocks}
            handleLinks={handleLinks}
            handleDrawer={handleDrawer}
            profile={profile}
            metricsOpen={metricsOpen}
            handleMetrics={handleMetrics}
            showMyAdvance={showMyAdvance}
            showLinksAndMetrics={showLinksAndMetrics}
            metricNumberSelected={metricNumberSelected}
            handleMetricNumberSelected={handleMetricNumberSelected}
          />
        </Drawer>
      </nav>
    </div>
  )
}

const mapStateToProps = state => {
  const {
    Login: {
      profile,
    },
    Addons: {
      data: addonsData,
      addonsConfig,
      addonsConfigValues,
    },
    Widgets: {
      customMetrics: {
        data: myAdvanceData,
      },
    },
  } = state

  const addonKeyedByName = _.keyBy(addonsData, 'name')

  const {
    show_links_goto: showLinks,
    show_metrics: showMyAdvance,
  } = addonKeyedByName


  const addonsConfigKeyedByAddonId = _.keyBy(addonsConfig, 'addon_id')
  const addonsConfigValuesKeyedByAddonConfigId = _.keyBy(addonsConfigValues, 'addon_config_id')

  const myAdvanceDataGroupedByFileName = _.keyBy(myAdvanceData, x => x.file_name)

  const showLinksAndMetrics = _.reduce(addonsData, (acum, addon) => {
    if (addon.name === 'show_links_goto') {
      const addonsConfigs = addonsConfigKeyedByAddonId[addon._id]
      const addonsConfigsValues = addonsConfigValuesKeyedByAddonConfigId[addonsConfigs._id]

      if (addonsConfigs && addonsConfigsValues) {
        return {
          ...acum,
          showLinksData: acum.showLinksData.concat(_.orderBy(addonsConfigsValues.value, 'order', 'asc')),
        }
      }

      return acum
    }

    if (addon.name === 'show_metrics') {
      const addonsConfigs = addonsConfigKeyedByAddonId[addon._id]
      const addonsConfigsValues = addonsConfigValuesKeyedByAddonConfigId[addonsConfigs._id]

      if (addonsConfigs && addonsConfigsValues) {
        const addonConfigValueValueKeyedByFileName = _.keyBy(addonsConfigsValues.value, x => x.file_name)

        return {
          ...acum,
          showMetricsData: acum.showMetricsData.concat(_.compact(_.map(addonsConfigsValues.value, x => {
            const match = myAdvanceDataGroupedByFileName[x.file_name]

            if (match) {
              const fileNameKeyed = addonConfigValueValueKeyedByFileName[match.file_name]
              const lastDay = fileNameKeyed ? fileNameKeyed.last_day : null

              if (!lastDay) {
                const today = moment().format('YYYY-MM-DD')

                if (moment(match.file_date).isSameOrAfter(today)) {
                  return {
                    ...fileNameKeyed,
                    file_date: (match.file_date
                      && moment(match.file_date).format('DD/MM/YYYY HH:mm'))
                      || 'Sin fecha',
                    links: (match.content
                      && _.orderBy(match.content, 'order', 'asc'))
                      || [],
                  }
                }

                return {
                  ...fileNameKeyed,
                  file_date: (match.file_date
                    && moment(match.file_date).format('DD/MM/YYYY HH:mm'))
                    || 'Sin fecha',
                  links: [],
                }
              }

              return {
                ...fileNameKeyed,
                file_date: (match.file_date
                  && moment(match.file_date).format('DD/MM/YYYY HH:mm'))
                  || 'Sin fecha',
                links: (match.content
                  && _.orderBy(match.content, 'order', 'asc'))
                  || [],
              }
            }

            return null
          }))),
        }
      }

      return acum
    }

    return acum
  }, {
    showLinksData: [],
    showMetricsData: [],
  })

  return {
    profile,
    showLinks,
    showLinksAndMetrics,
    showMyAdvance,
  }
}

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(LOGOUT()),
})

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(DrawerComponent)
